import React from "react";

function SvgIcMapPoi035(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M23.821 16.056a1.5 1.5 0 11-.779-2.9 1.5 1.5 0 01.78 2.9M22.13 20.07c-.71.19-1.702 1.375-1.93.517-.23-.856.804-1.878 1.515-2.068.711-.191 2.118.177 2.347 1.033.23.858-1.22.327-1.932.518m4.248-9.93a18.554 18.554 0 00-.598-1.837 11.26 11.26 0 01-4.016 2.987l-.208 1.307a20.5 20.5 0 01-.445 2.093c-.654 2.44-1.685 4.593-2.95 6.31 1.534 1.322 3.23 1.917 4.798 1.497 3.467-.928 4.998-6.461 3.42-12.356m-10.533 6.813a1.5 1.5 0 11-2.897-.776 1.5 1.5 0 112.897.776m-2.95 3.358c-.23.857-1.636 1.224-2.348 1.034-.711-.19-1.745-1.212-1.515-2.069.229-.856 1.22.327 1.93.518.712.19 2.163-.339 1.934.517m-4.778-5.428a1.499 1.499 0 112.898.776 1.5 1.5 0 01-2.898-.776m4.769-2.346A11.278 11.278 0 017.22 8.97a18.574 18.574 0 00-.598 1.84c-1.58 5.893-.047 11.425 3.419 12.355 3.467.93 7.56-3.097 9.139-8.992.17-.637.303-1.268.4-1.89a11.277 11.277 0 01-6.692.256"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi035;
